const columns = [
  {
    no: "专栏 01",
    title: "国产剧「群像戏」为何越来越能打？",
    read: "12 分钟",
    views: "8.6 万",
    image: "https://readdy.ai/api/search-image?query=editorial%20illustration%20of%20drama%20storytelling%20with%20film%20clapperboard%20and%20layered%20faces%20silhouettes%2C%20warm%20crimson%20and%20cream%20palette%2C%20magazine%20layout&width=800&height=520&seq=col-1&orientation=landscape",
    excerpt: "从《万家灯火》的收视口碑双收谈起，拆解近年来群像剧在选角、台词与日常细节上的创作方法论。",
  },
  {
    no: "专栏 02",
    title: "从录音室到舞台：一首都市单曲的诞生",
    read: "10 分钟",
    views: "6.2 万",
    image: "https://readdy.ai/api/search-image?query=behind%20the%20scenes%20of%20a%20music%20production%20studio%20with%20audio%20console%20and%20sheet%20music%2C%20warm%20amber%20lighting%2C%20editorial%20photography&width=800&height=520&seq=col-2&orientation=landscape",
    excerpt: "跟随唱作人陈屿，回顾《夜航西飞》从词曲雏形、编曲讨论到最终混音的完整公开创作记录。",
  },
  {
    no: "专栏 03",
    title: "红毯造型背后的「视觉叙事」",
    read: "8 分钟",
    views: "5.1 万",
    image: "https://readdy.ai/api/search-image?query=high%20fashion%20editorial%20detail%20of%20elegant%20fabric%20and%20accessories%20with%20soft%20golden%20light%2C%20couture%20detail%2C%20warm%20editorial%20style&width=800&height=520&seq=col-3&orientation=landscape",
    excerpt: "深究高定礼服如何在造型团队手中完成从东方纹样到国际视野的表达，读懂红毯上的每一处细节。",
  },
];

export default function Columns() {
  return (
    <section id="columns" className="mx-auto max-w-7xl px-4 py-16 md:px-6" aria-label="深度长文">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-amber2-600">
            <i className="ri-quill-pen-fill" aria-hidden="true"></i> 编辑部专栏
          </span>
          <h2 className="mt-2 font-serif text-3xl font-black text-ink-950 md:text-4xl">值得细读的长文</h2>
          <p className="mt-2 max-w-xl text-sm text-ink-600">
            不追风、不转载，这里只产出关于影视、音乐与时尚行业的深度梳理与独立观察。
          </p>
        </div>
        <span className="flex items-center gap-2 whitespace-nowrap rounded-full border border-paper-200 bg-paper-100 px-4 py-2 text-xs text-ink-600">
          <i className="ri-calendar-line text-crimson-500" aria-hidden="true"></i> 每周二 · 周五更新
        </span>
      </div>

      <div className="mt-8 grid gap-5 lg:grid-cols-3">
        {columns.map((c) => (
          <article
            key={c.no}
            className="group flex flex-col overflow-hidden rounded-2xl border border-paper-200 bg-paper-100 transition hover:border-gold-500/60"
          >
            <div className="relative aspect-[16/10] overflow-hidden">
              <img
                src={c.image}
                alt={`深度专栏：${c.title}`}
                className="h-full w-full object-cover object-top transition duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 rounded-md bg-ink-950/80 px-2.5 py-1 text-[11px] font-semibold text-amber2-300 backdrop-blur">
                {c.no}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="font-serif text-lg font-bold leading-snug text-ink-900 group-hover:text-crimson-500">
                {c.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-ink-600">{c.excerpt}</p>
              <div className="mt-4 flex items-center justify-between border-t border-paper-200 pt-3 text-xs text-ink-400">
                <span>
                  <i className="ri-time-line mr-1 text-crimson-400" aria-hidden="true"></i>阅读约 {c.read}
                </span>
                <span>
                  <i className="ri-eye-line mr-1" aria-hidden="true"></i> {c.views} 阅读
                </span>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}